<template>
    <div id="compliance-alerts-form">
        <div v-if="!showThankYou">
            <div class="compliance-alerts-form-title">
                Sign Up for {{ items.length === 1 ? `${items[0].name} ` : '' }}Compliance Alerts
            </div>

            <div class="d-flex flex-row" style="flex-wrap: wrap;">
                <div class="input-group name-input">
                    <label for="firstName">First Name</label>
                    <input v-model="firstName" placeholder="John" type="text" name="firstName" id="firstName" class="isigma_members_input">
                </div>
                <div class="input-group name-input">
                    <label for="lastName">Last Name</label>
                    <input v-model="lastName" placeholder="Doe" type="text" name="lastName" id="lastName" class="isigma_members_input">
                </div>
            </div>
            <div class="input-group">
                <label for="email">Email</label>
                <input v-model="email" placeholder="example@example.com" type="email" name="email" id="email" class="isigma_members_input">
            </div>

            <div class="input-group" style="margin: 43px 0;">
                <label class="checkbox-label">
                    <input type="checkbox" v-model="agree">
                    <span>By checking this box I agree to receive recurring automated notifications from i-SIGMA. View Terms & Privacy.
                    </span>
                </label>
            </div>

            <div class="input-group">
                <button
                    :disabled="!agree || !email || !firstName || !lastName"
                    class="isigma_members_btn isigma_members_btn-black" @click="submit">
                    Submit
                </button>
            </div>
        </div>
        <div v-if="showThankYou">
            <div class="compliance-alerts-form-title">Thank you</div>

            <div style="margin: 37px 0 18px 0;">
                <button
                    class="isigma_members_btn isigma_members_btn-black"
                    
                    @click="$emit('close')"
                >
                    Sign Up for Compliance Alerts for Another Vendor
                </button>
            </div>

            <div>
                <a
                    href="/"
                    class="isigma_members_btn"
                >
                    Go Back to i-SIGMA Homepage
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        firstName: null,
        lastName: null,
        email: null,
        agree: false,
        loading: false,
        showThankYou: false
    }),
    methods: {
        submit () {
            if (this.agree && this.items.length) {
                this.saveAlerts({
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    ids: this.items.map(({ rhythm_id }) => rhythm_id),
                })
            }
        },
        async saveAlerts (payload) {
            const options = {
                method: 'POST',
                url: '/wp-admin/admin-ajax.php',
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                action: 'isigma_save_alert',
                ...payload
                }
            };

            try {
                this.loading = true
                await axios.request(options)
                this.showThankYou = true
            } catch (err) {
                alert(err.message || err)
            } finally {
                this.loading = false
            }
        }
    },
    emits: ['close']
}
</script>

<style scoped>
#compliance-alerts-form {
    border-radius: 14px;
    background: rgba(245, 245, 245, 0.95);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(2px);
    padding: 40px 30px;
}

.compliance-alerts-form-title {
    color: #000;
    font-family: Arial;
    font-size: 22px;
    font-weight: 700;
}

.input-group {
    padding: 0 0.75rem;
    margin-top: 20px;
}

.input-group label {
    display: inline-block;
    margin-bottom: 6px;
}

.input-group .checkbox-label {
    margin: 0;
}

.name-input {
    width: 50%;
}

@media screen and (max-width: 767px) {
  .name-input {
    width: 100%;
  }
}
</style>